import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// --------------------------------------------------------------------------
// 安全装置: 本番環境（production）なのにAPI先が localhost になっていたら警告を出す
// --------------------------------------------------------------------------
if (
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_COMIKET_API_URL_BASE?.includes('localhost')
) {
    alert('【緊急】ビルド設定ミス！本番環境なのにAPIがlocalhost向いてるよ！シェル変数残ってない？');
    throw new Error('Production build pointing to localhost.');
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
